import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Menu } from "@headlessui/react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";

// Custom
import Image from "../Image/Image";

function NavContainer({ group, fluid, children }) {
  if (group && ["fwwr", "umpquafish", "tracker-foundation"].includes(group.name)) {
    return (
      <div className="mx-auto w-full max-w-screen-xl md:px-12">
        <Row>{children}</Row>
      </div>
    );
  } else {
    return (
      <Container className="d-none d-md-block py-1" fluid={fluid}>
        <Row>{children}</Row>
      </Container>
    );
  }
}

class DesktopNav extends Component {
  render() {
    const { user, tracker, location, trackerSubdomain } = this.props;
    const { pathname } = location;
    const home = tracker
      ? trackerSubdomain
        ? "/"
        : `/t/${tracker.name}`
      : "/";
    let fluidNav = false;

    const isCustomGroup = tracker && ["fwwr", "umpquafish", "tracker-foundation"].includes(
      tracker.name
    );

    if (pathname.includes("/admin") && user && user.admin) {
      fluidNav = true;
    }

    return (
      <NavContainer group={tracker} fluid={fluidNav}>
        {tracker && (
          <Col className={(fluidNav ? "pl-4 " : "") + "col-4"}>
            <a
              href={home}
              className="mb-0 my-2 d-flex align-items-center py-2 text-decoration-none mr-3"
              style={{
                height: !tracker ? "40px" : "auto"
              }}
            >
              {!tracker.private && (
                <Image
                  resize={{
                    height: 76,
                    width: 76
                  }}
                  alt=""
                  sourceKey={tracker.headerImageKey}
                  className={
                    isCustomGroup
                      ? "img-icon-sm rounded-lg mr-2"
                      : "img-icon-sm rounded mr-2"
                  }
                />
              )}

              {tracker && (
                <h6 className="d-inline-block font-weight-extrabold mb-0">
                  {tracker.displayName}
                </h6>
              )}

              {!tracker && (
                <img
                  src="https://jointracker-assets.s3-us-west-2.amazonaws.com/tracker.svg"
                  alt="logo"
                  className="tracker-logo"
                  draggable={false}
                />
              )}
            </a>
          </Col>
        )}

        {!tracker && (
          <Col className="col-4 mx-auto d-flex justify-content-center">
            <a
              href={home}
              className="mb-0 my-2 d-flex align-items-center py-2 text-decoration-none mr-3"
              style={{
                height: !tracker ? "40px" : "auto"
              }}
            >
              <svg
                width="81"
                height="18"
                viewBox="0 0 83 20"
                fill="#2A2F45"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M82.6421 10.3828C82.4483 10.33 82.2546 10.2948 82.0608 10.2771C81.8847 10.2595 81.7086 10.2507 81.5324 10.2507C80.9512 10.2507 80.458 10.3564 80.0529 10.5678C79.6654 10.7791 79.3484 11.0345 79.1018 11.334C78.8728 11.6334 78.7055 11.9592 78.5998 12.3115C78.4941 12.6638 78.4413 12.972 78.4413 13.2362V19.9997H74.1084V6.84254H78.2828L78.547 8.34848H78.5998C78.9345 7.67917 79.1458 7.52946 79.7623 7.10674C80.3788 6.68402 81.0921 6.47266 81.9023 6.47266C82.0785 6.47266 82.2458 6.48146 82.4043 6.49908C82.5804 6.51669 82.7213 6.54311 82.827 6.57834L82.6421 10.3828Z M69.0356 11.44C69.0356 10.753 68.8154 10.163 68.3751 9.66981C67.9524 9.17664 67.3095 8.93005 66.4464 8.93005C66.0237 8.93005 65.6362 9.0005 65.2839 9.14141C64.9317 9.2647 64.6234 9.44084 64.3592 9.66981C64.095 9.89878 63.8837 10.1718 63.7251 10.4888C63.5666 10.7883 63.4786 11.1053 63.4609 11.44H69.0356ZM73.025 13.1044C73.025 13.2806 73.025 13.4567 73.025 13.6328C73.025 13.809 73.0162 13.9763 72.9986 14.1348H63.4609C63.4962 14.5047 63.6019 14.8393 63.778 15.1388C63.9717 15.4382 64.2095 15.7024 64.4913 15.9314C64.7908 16.1427 65.1166 16.3101 65.4689 16.4334C65.8387 16.5566 66.2174 16.6183 66.6049 16.6183C67.2919 16.6183 67.8731 16.495 68.3487 16.2484C68.8242 15.9842 69.2117 15.6496 69.5111 15.2444L72.523 17.1467C71.9066 18.045 71.0875 18.7407 70.066 19.2339C69.062 19.7094 67.8907 19.9472 66.5521 19.9472C65.5657 19.9472 64.6322 19.7975 63.7516 19.4981C62.8709 19.181 62.0959 18.7319 61.4266 18.1507C60.7749 17.5518 60.2553 16.8208 59.8678 15.9578C59.4979 15.0947 59.313 14.1084 59.313 12.9987C59.313 11.9243 59.4979 10.9556 59.8678 10.0925C60.2377 9.21186 60.7397 8.4721 61.3738 7.87324C62.0078 7.25678 62.7564 6.78122 63.6195 6.44656C64.4825 6.11191 65.416 5.94458 66.42 5.94458C67.3887 5.94458 68.2782 6.11191 69.0884 6.44656C69.8986 6.7636 70.5944 7.23036 71.1756 7.84682C71.7568 8.46329 72.206 9.21186 72.523 10.0925C72.8577 10.9732 73.025 11.9772 73.025 13.1044Z M59.2864 19.9743H53.9231L49.6167 13.6599H49.5374V19.9743H45.1781V1.32174L49.5374 0.000732422V12.154H49.6167L53.8175 6.81711H59.0751L54.0024 12.7616L59.2864 19.9743Z M41.6911 10.6209C41.4445 10.3039 41.1099 10.0485 40.6871 9.85475C40.2644 9.661 39.8329 9.56413 39.3925 9.56413C38.9346 9.56413 38.5207 9.661 38.1508 9.85475C37.7809 10.0309 37.4639 10.2775 37.1997 10.5945C36.9355 10.8939 36.7241 11.2462 36.5656 11.6513C36.4247 12.0564 36.3542 12.488 36.3542 12.9459C36.3542 13.4038 36.4247 13.8354 36.5656 14.2405C36.7065 14.6456 36.9091 15.0067 37.1733 15.3237C37.4551 15.6231 37.7809 15.8609 38.1508 16.037C38.5383 16.2132 38.9698 16.3012 39.4454 16.3012C39.8857 16.3012 40.3173 16.222 40.74 16.0635C41.1803 15.8873 41.5326 15.6407 41.7968 15.3237L44.201 18.2563C43.655 18.7847 42.9504 19.1987 42.0874 19.4981C41.2243 19.7975 40.3084 19.9472 39.3397 19.9472C38.3005 19.9472 37.3318 19.7887 36.4335 19.4717C35.5352 19.1546 34.7514 18.6967 34.0821 18.0978C33.4304 17.4813 32.9108 16.7416 32.5233 15.8785C32.1534 15.0155 31.9685 14.0379 31.9685 12.9459C31.9685 11.8715 32.1534 10.9027 32.5233 10.0397C32.9108 9.17664 33.4304 8.44568 34.0821 7.84682C34.7514 7.23036 35.5352 6.7636 36.4335 6.44656C37.3318 6.11191 38.2917 5.94458 39.3133 5.94458C39.7888 5.94458 40.2556 5.98861 40.7136 6.07668C41.1891 6.16475 41.6383 6.28804 42.061 6.44656C42.5013 6.58747 42.8976 6.77241 43.2499 7.00138C43.6198 7.21274 43.9368 7.45052 44.201 7.71472L41.6911 10.6209Z M26.9485 13.9234H26.3936C25.9181 13.9234 25.4337 13.9498 24.9405 14.0027C24.465 14.0379 24.0334 14.1172 23.646 14.2405C23.2761 14.3638 22.9678 14.5487 22.7213 14.7953C22.4747 15.0243 22.3514 15.3325 22.3514 15.72C22.3514 15.9666 22.4042 16.1779 22.5099 16.3541C22.6332 16.5302 22.7829 16.6711 22.959 16.7768C23.1352 16.8825 23.3377 16.9617 23.5667 17.0146C23.7957 17.0498 24.0158 17.0674 24.2272 17.0674C25.1079 17.0674 25.7772 16.8296 26.2351 16.3541C26.7107 15.8609 26.9485 15.2004 26.9485 14.3726V13.9234ZM18.996 8.29595C19.771 7.55618 20.6693 7.00136 21.6909 6.63148C22.7301 6.2616 23.7869 6.07666 24.8613 6.07666C25.9709 6.07666 26.9044 6.21757 27.6618 6.49938C28.4368 6.76358 29.0621 7.1863 29.5376 7.76755C30.0132 8.33117 30.3567 9.05332 30.568 9.93399C30.797 10.797 30.9115 11.8274 30.9115 13.0251V19.6566H26.9485V18.2563H26.8692C26.5345 18.8023 26.0238 19.2251 25.3368 19.5245C24.6675 19.8239 23.9366 19.9736 23.144 19.9736C22.6156 19.9736 22.0696 19.9032 21.5059 19.7623C20.9423 19.6214 20.4227 19.3924 19.9471 19.0753C19.4892 18.7583 19.1105 18.3356 18.8111 17.8072C18.5117 17.2788 18.3619 16.6271 18.3619 15.8521C18.3619 14.901 18.6173 14.1348 19.1281 13.5535C19.6565 12.9723 20.3258 12.5232 21.136 12.2061C21.9639 11.8891 22.8798 11.6777 23.8837 11.572C24.8877 11.4664 25.8652 11.4135 26.8164 11.4135V11.2022C26.8164 10.5505 26.5874 10.0749 26.1294 9.77547C25.6715 9.45843 25.1079 9.29991 24.4386 9.29991C23.8221 9.29991 23.2232 9.43201 22.642 9.69621C22.0784 9.96041 21.594 10.2775 21.1889 10.6473L18.996 8.29595Z M17.7808 10.3828C17.587 10.33 17.3933 10.2948 17.1995 10.2771C17.0234 10.2595 16.8473 10.2507 16.6711 10.2507C16.0899 10.2507 15.5967 10.3564 15.1916 10.5678C14.8041 10.7791 14.4871 11.0345 14.2405 11.334C14.0115 11.6334 13.8442 11.9592 13.7385 12.3115C13.6328 12.6638 13.58 12.972 13.58 13.2362V19.9997H9.24707V6.84254H13.4214L13.6856 8.34848H13.7385C14.0731 7.67917 14.2845 7.52946 14.901 7.10674C15.5174 6.68402 16.2308 6.47266 17.041 6.47266C17.2171 6.47266 17.3845 6.48146 17.543 6.49908C17.7191 6.51669 17.86 6.54311 17.9657 6.57834L17.7808 10.3828Z M5.15192 9.7483V14.7681C5.15192 15.3846 5.2664 15.8513 5.49538 16.1684C5.74197 16.4678 6.17349 16.6175 6.78996 16.6175C7.00132 16.6175 7.22149 16.5999 7.45046 16.5647C7.69705 16.5295 7.89961 16.4766 8.05813 16.4062L8.11097 19.5766C7.81154 19.6822 7.43285 19.7703 6.9749 19.8408C6.51696 19.9288 6.05901 19.9729 5.60106 19.9729C4.72039 19.9729 3.98063 19.8672 3.38177 19.6558C2.78292 19.4269 2.29855 19.1098 1.92867 18.7047C1.5764 18.282 1.321 17.7888 1.16248 17.2252C1.00396 16.6439 0.924703 16.001 0.924703 15.2965V9.7483H0V6.49863H0.898283V4.3586L5.15192 3.0376V6.49863H8.24307V9.7483H5.15192Z"
                />
              </svg>
            </a>
          </Col>
        )}

        {tracker && (
          <Col
            className={
              (fluidNav ? "pr-4 " : "") +
              "col-8 d-flex justify-content-end align-items-center"
            }
          >
            {/* Home */}
            {user && (
              <a href={home} className="text-secondary mx-3 my-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="img-icon-xs"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                    d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                  />
                </svg>
              </a>
            )}

            {tracker &&
              user &&
              user.adminData &&
              user.admin &&
              (user.adminData.users > 0 || user.adminData.posts > 0) && (
                <div className="position-relative mx-3 my-2">
                  <Menu>
                    <Menu.Button className="border-0 bg-white text-secondary transition-color p-0 position-relative">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="img-icon-xs"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={1.5}
                          d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                        />
                      </svg>
                      <span
                        className={
                          (tracker.name === "hawaii"
                            ? "btn-lava"
                            : tracker.name === "roseburg"
                            ? "btn-green"
                            : "btn-primary") +
                          " position-absolute top-0 left-0 rounded-circle"
                        }
                        style={{
                          width: "6px",
                          height: "6px"
                        }}
                      />
                    </Menu.Button>

                    <Menu.Items className="headless-ui-dropdown border w-56 d-flex flex-column position-absolute right-0 mt-2 bg-white rounded shadow">
                      <Menu.Item className="px-3 py-2 my-2 d-block font-weight-medium medium text-dark">
                        <span>Notifications</span>
                      </Menu.Item>

                      <hr className="w-100 mt-0 mb-2" />

                      <div className="pb-2">
                        {user.adminData.users > 0 && (
                          <Menu.Item className="px-3 py-2 text-decoration-none d-block text-dark medium font-weight-medium d-flex justify-content-between">
                            <Link
                              to={
                                trackerSubdomain
                                  ? "/admin/"
                                  : `/t/${tracker.name}/admin/member-requests`
                              }
                            >
                              <span>Group Requests</span>

                              <span className="badge badge-primary">
                                {user.adminData.users}
                              </span>
                            </Link>
                          </Menu.Item>
                        )}

                        {user.adminData.posts > 0 && (
                          <Menu.Item className="px-3 py-2 text-decoration-none d-block text-dark medium font-weight-medium d-flex justify-content-between">
                            <Link
                              to={
                                trackerSubdomain
                                  ? "/admin/pending-posts"
                                  : `/t/${tracker.name}/admin/pending-posts`
                              }
                            >
                              <span>Pending Posts</span>

                              <span className="badge badge-primary">
                                {user.adminData.posts}
                              </span>
                            </Link>
                          </Menu.Item>
                        )}
                      </div>
                    </Menu.Items>
                  </Menu>
                </div>
              )}

            {/* Sign in and Sign up */}
            {!user && tracker && (
              <>
                <Link
                  to={`/login${
                    tracker && !trackerSubdomain ? "?t=" + tracker.name : ""
                  }`}
                  className="font-weight-medium medium text-muted my-2 mx-3 text-decoration-none"
                >
                  Login
                </Link>

                {/* {tracker?.name !== "umpquafish" && <Link
                  to={`/signup${
                    tracker && !trackerSubdomain ? "?t=" + tracker.name : ""
                  }`}
                  className={
                    (tracker && tracker.name === "hawaii" ? "mx-3" : "ml-3") +
                    " font-weight-medium medium text-muted my-2 ml-3 text-decoration-none"
                  }
                >
                  Signup
                </Link>} */}
              </>
            )}

            {user && (
              <div className="position-relative mx-3 mt-2">
                <Menu>
                  <Menu.Button className="border-0 bg-white text-secondary transition-color p-0">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="img-icon-xs"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={1.5}
                        d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                      />
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={1.5}
                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                    </svg>
                  </Menu.Button>

                  <Menu.Items className="headless-ui-dropdown border w-56 d-flex flex-column position-absolute right-0 mt-2 bg-white rounded shadow">
                    <Menu.Item className="text-decoration-none px-3 py-2 my-2">
                      <Link to="/profile?tab=settings">
                        <Image
                          resize={{
                            width: 76,
                            height: 76
                          }}
                          sourceKey={user.profilePhotoKey}
                          alt=""
                          className="img-icon-sm mb-2 rounded-circle"
                        />

                        <div>
                          <span className="d-block font-weight-medium small text-secondary">
                            Signed in as
                          </span>
                          <span className="d-block medium font-weight-bold text-dark">
                            {user.firstname} {user.lastname}
                          </span>
                        </div>
                      </Link>
                    </Menu.Item>

                    <hr className="w-100 mt-0 mb-2" />

                    <div className="pb-2">
                      <Menu.Item className="px-3 py-2 text-decoration-none d-block text-dark medium ">
                        <Link to="/profile?tab=posts">Profile</Link>
                      </Menu.Item>

                      {user.admin && tracker && (
                        <Menu.Item className="px-3 py-2 text-decoration-none d-block text-dark medium">
                          <Link
                            to={
                              (trackerSubdomain ? "" : `/t/${tracker.name}`) +
                              `/admin/users`
                            }
                          >
                            Admin
                          </Link>
                        </Menu.Item>
                      )}

                      <Menu.Item className="px-3 py-2 text-decoration-none d-block text-dark medium">
                        <Link to="/settings">Settings</Link>
                      </Menu.Item>

                      {tracker &&
                        ["roseburg", "hawaii"].includes(tracker.name) && (
                          <Menu.Item className="px-3 py-2 text-decoration-none d-block text-dark medium">
                            <Link
                              to={
                                trackerSubdomain
                                  ? "/support"
                                  : `/t/${tracker.name}/support`
                              }
                            >
                              Donate
                            </Link>
                          </Menu.Item>
                        )}

                      <hr className="w-100 my-2" />

                      <Menu.Item className="px-3 py-2 text-decoration-none d-block text-dark medium">
                        <a href="/api/users/current/logout">Logout</a>
                      </Menu.Item>
                    </div>
                  </Menu.Items>
                </Menu>
              </div>
            )}

            {tracker && tracker.name === "hawaii" && (
              <div className="position-relative mx-3 my-2">
                <Menu>
                  <Menu.Button className="border-0 bg-white text-secondary transition-color p-0">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      version="1.1"
                      id="Layer_1"
                      x="0px"
                      y="0px"
                      viewBox="0 0 439.48 439.48"
                      style={{ enableBackground: "new 0 0 439.48 439.48" }}
                      xmlSpace="preserve"
                      width={28}
                      height={28}
                    >
                      <g>
                        <g>
                          <rect
                            x="208.737"
                            y="179.318"
                            style={{ fill: "#ED2E2E" }}
                            width="22.006"
                            height="108.426"
                          />
                          <path
                            style={{ fill: "#CCCCCC" }}
                            d="M402.733,372.11H36.753c0,0,37.72-15.45,77.89-38.61c32.81-18.9,67.24-42.94,84.1-67.88h42    c16.85,24.94,51.29,48.99,84.1,67.89C365.013,356.66,402.733,372.11,402.733,372.11z"
                          />
                          <path
                            style={{ fill: "#CCCCCC" }}
                            d="M253.74,180.372c0,8.836,7.163,16,16,16c8.626,0,15.638-6.831,15.969-15.375    c3.687,1.758,7.88,2.624,12.304,2.312c12.068-0.851,21.857-10.671,22.67-22.741c0.474-7.031-2.023-13.481-6.357-18.222    c3.313-2.932,5.414-7.203,5.414-11.975c0-8.836-7.163-16-16-16c-0.522,0-1.038,0.029-1.547,0.078    c1.304-3.488,1.841-7.349,1.39-11.385c-1.307-11.683-11.046-20.916-22.78-21.645c-7.032-0.437-13.471,2.098-18.192,6.465    c-3.823-8.551-12.398-14.513-22.371-14.513c-8.579,0-16.124,4.413-20.5,11.089c-4.376-6.676-11.921-11.089-20.5-11.089    c-9.973,0-18.548,5.962-22.371,14.513c-4.721-4.367-11.16-6.901-18.192-6.465c-11.734,0.729-21.473,9.961-22.78,21.645    c-0.451,4.035,0.086,7.897,1.39,11.385c-0.51-0.049-1.025-0.078-1.547-0.078c-8.837,0-16,7.164-16,16    c0,4.772,2.1,9.043,5.414,11.975c-4.334,4.741-6.83,11.19-6.357,18.222c0.813,12.07,10.603,21.89,22.67,22.741    c4.424,0.312,8.617-0.554,12.304-2.312c0.331,8.544,7.343,15.375,15.969,15.375c8.837,0,16-7.164,16-16l1.948,3.146    c6.872,11.1,18.998,17.854,32.052,17.854h0c13.055,0,25.181-6.754,32.052-17.854L253.74,180.372z"
                          />
                          <path
                            style={{ fill: "#D82525" }}
                            d="M198.741,257.871c-2.485,0-4.5-2.015-4.5-4.5v-41c0-2.485,2.015-4.5,4.5-4.5s4.5,2.015,4.5,4.5v41    C203.241,255.857,201.227,257.871,198.741,257.871z"
                          />
                          <path
                            style={{ fill: "#D82525" }}
                            d="M240.739,257.871c-2.485,0-4.5-2.015-4.5-4.5v-41c0-2.485,2.015-4.5,4.5-4.5s4.5,2.015,4.5,4.5v41    C245.239,255.857,243.225,257.871,240.739,257.871z"
                          />
                          <path
                            style={{
                              fill: "none",
                              stroke: "#808080",
                              strokeWidth: 7,
                              strokeLinecap: "round",
                              strokeMiterlimit: 10
                            }}
                            d="M163.275,150.049    c-4.882-4.882-4.882-12.796,0-17.678c4.882-4.882,12.796-4.882,17.678,0"
                          />
                          <path
                            style={{
                              fill: "none",
                              stroke: "#808080",
                              strokeWidth: 7,
                              strokeLinecap: "round",
                              strokeMiterlimit: 10
                            }}
                            d="M247.741,130.473    c7.255-7.255,19.017-7.255,26.271,0c7.255,7.255,7.255,19.017,0,26.271"
                          />
                          <path
                            style={{ fill: "#B3B3B3" }}
                            d="M290.713,345.91c-0.99-0.33-32.83-11.32-54.23-40.92c0,0-12.74,42.93-16.74,54.93    c-4-12-16.75-54.93-16.75-54.93c-21.4,29.6-53.24,40.59-54.23,40.92c13.99-11.01,27.98-33.99,27.98-33.99    c-21.4,12.01-53.96,19.76-62.1,21.58c32.81-18.9,67.24-42.94,84.1-67.88h42c16.85,24.94,51.29,48.99,84.1,67.89    c-8.13-1.82-40.7-9.58-62.11-21.59C262.733,311.92,276.723,334.9,290.713,345.91z"
                          />
                        </g>
                        <g>
                          <path
                            style={{ fill: "#0FBC30" }}
                            d="M439.48,394.788H0c0-4.43,1.13-8.59,3.12-12.22c1.17-2.14,2.64-4.09,4.35-5.8    c4.61-4.62,10.99-7.47,18.03-7.47h388.48c9.65,0,18.05,5.36,22.38,13.27C438.35,386.198,439.48,390.358,439.48,394.788z"
                          />
                          <path
                            style={{ fill: "#07A521" }}
                            d="M439.48,394.788H0c0-4.43,1.13-8.59,3.12-12.22h433.24    C438.35,386.198,439.48,390.358,439.48,394.788z"
                          />
                        </g>
                      </g>
                    </svg>
                  </Menu.Button>

                  <Menu.Items className="headless-ui-dropdown border w-56 d-flex flex-column position-absolute right-0 mt-2 bg-white rounded shadow">
                    <Menu.Item className="px-3 py-2 my-2 d-block font-weight-medium medium text-dark">
                      <span>Monitoring</span>
                    </Menu.Item>

                    <hr className="w-100 mt-0 mb-2" />

                    <div className="pb-2">
                      <Menu.Item className="px-3 py-2 text-decoration-none d-block text-dark medium ">
                        <Link
                          to={
                            trackerSubdomain
                              ? "/monitoring/webcams"
                              : "/t/hawaii/monitoring/webcams"
                          }
                        >
                          Webcams
                        </Link>
                      </Menu.Item>

                      <Menu.Item className="px-3 py-2 text-decoration-none d-block text-dark medium ">
                        <Link
                          to={
                            trackerSubdomain
                              ? "/monitoring/tilt"
                              : "/t/hawaii/monitoring/tilt"
                          }
                        >
                          Tilt
                        </Link>
                      </Menu.Item>

                      <Menu.Item className="px-3 py-2 text-decoration-none d-block text-dark medium ">
                        <Link
                          to={
                            trackerSubdomain
                              ? "/monitoring/2-year-gps"
                              : "/t/hawaii/monitoring/2-year-gps"
                          }
                        >
                          2 Year GPS
                        </Link>
                      </Menu.Item>

                      <Menu.Item className="px-3 py-2 text-decoration-none d-block text-dark medium ">
                        <Link
                          to={
                            trackerSubdomain
                              ? "/monitoring/10-year-gps"
                              : "/t/hawaii/monitoring/10-year-gps"
                          }
                        >
                          10 Year GPS
                        </Link>
                      </Menu.Item>
                    </div>
                  </Menu.Items>
                </Menu>
              </div>
            )}

            {/* Profile */}
            {user && (
              <Link to="/profile?tab=posts">
                <Image
                  resize={{
                    width: 56,
                    height: 56
                  }}
                  sourceKey={user.profilePhotoKey}
                  alt=""
                  className={
                    (user &&
                    tracker &&
                    ["roseburg", "hawaii"].includes(tracker.name)
                      ? "ml-3 "
                      : "ml-3 ") +
                    (pathname === "/profile" ? "active " : "") +
                    "my-2 img-icon-xs rounded-circle"
                  }
                />
              </Link>
            )}

            {/* {user && tracker && tracker.name === "roseburg" &&
              <Link to={trackerSubdomain ? "/advertise" : "/t/roseburg/advertise"} className="ml-3 font-weight-bold text-decoration-none d-block px-3 py-2 medium rounded pill text-white btn-green">
                Advertise
              </Link>
            }

            {user && tracker && tracker.name === "hawaii" &&
              <Link to={trackerSubdomain ? "/advertise" : "/t/hawaii/advertise"} className="ml-3 font-weight-bold text-decoration-none d-block px-3 py-2 medium rounded pill text-white btn-lava">
                Advertise
              </Link>
            } */}
          </Col>
        )}
      </NavContainer>
    );
  }
}

export default DesktopNav;
